/*

Note:
1. please replace class/IDs of error message, promotion code box and discount remove button.
document.querySelector("#invalid-discount")
document.querySelector('#promotion_code')
document.querySelector(".discount-code-input")

*/

function _promoStr(key) {
  var s = (typeof theme !== 'undefined' && theme.promotionStrings) ? theme.promotionStrings : {};
  var fb = {
    thankYouCode: 'Thank you for using promo code ',
    eligible: 'You are eligible for ',
    addAny: 'Add any product to the cart to get ',
    spend: 'Spend ',
    more: ' more to get ',
    congratulations: 'Congratulations! You are eligible for ',
    andWord: ' and ',
    loginToUnlock: 'Login to unlock!'
  };
  return (s[key] != null && s[key] !== '') ? s[key] : (fb[key] || '');
}

function _formatPromotionMoney(amount) {
  var numericAmount = Number(amount || 0);
  if (!Number.isFinite(numericAmount)) numericAmount = 0;
  if (typeof theme !== 'undefined' && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.shopSettings && theme.shopSettings.moneyFormat) {
    return theme.Currency.formatMoney(Math.round(numericAmount * 100), theme.shopSettings.moneyFormat);
  }
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && typeof theme !== 'undefined' && theme.shopSettings && theme.shopSettings.moneyFormat) {
    return Shopify.formatMoney(Math.round(numericAmount * 100), theme.shopSettings.moneyFormat);
  }
  return '$' + numericAmount.toFixed(2);
}

function normalizeRuleList(value, toLowerCase) {
  if (Array.isArray(value)) {
    return value
      .map((entry) => String(entry).trim())
      .filter((entry) => entry !== '')
      .map((entry) => (toLowerCase ? entry.toLowerCase() : entry));
  }
  if (typeof value === 'string') {
    return value
      .split(/\s*,\s*/)
      .map((entry) => entry.trim())
      .filter((entry) => entry !== '')
      .map((entry) => (toLowerCase ? entry.toLowerCase() : entry));
  }
  return [];
}

window.refreshCart = window.refreshCart || function () {
  return new Promise(function (resolve) {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(resolve, 200);
  });
};

function getPromotionContainers() {
  return Array.from(document.querySelectorAll('[data-gwp-promocode]'));
}

function getPromotionContainer(target) {
  if (target && target.closest) {
    const container = target.closest('[data-gwp-promocode]');
    if (container) return container;
  }
  return getPromotionContainers()[0] || null;
}

function getPromotionInput(container) {
  return container ? container.querySelector('#promotion_code') : null;
}

function getPromotionInputValue(target) {
  const container = getPromotionContainer(target);
  const input = getPromotionInput(container);
  if (input && input.value != null) return input.value;
  const fallback = document.querySelector('[data-gwp-promocode] #promotion_code');
  return fallback ? fallback.value : '';
}

function setPromotionInputState(value, readonly, codeApplied) {
  getPromotionContainers().forEach((container) => {
    const input = getPromotionInput(container);
    const inputWrap = container.querySelector('.discount-code-input');
    if (input) {
      input.value = value || '';
      if (readonly) {
        input.setAttribute('readonly', 'readonly');
      } else {
        input.removeAttribute('readonly');
      }
    }
    if (inputWrap) {
      inputWrap.classList.toggle('code-applied', !!codeApplied);
    }
  });
}

/* Add gift product to cart */

_addGiftProduct = async function(gift_data) {
  gift_data = Array.isArray(gift_data) ? gift_data : [];
  gift_data = gift_data.filter((gift) => {
    return !window.cartItemsData.giftsInCart.includes(Number(gift.id));
  });
  if(gift_data.length <= 0) { return false; }
  var productData = {
      'items': gift_data
  };
  return fetch(theme.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(productData)
  })
  .then(response => {
    if (response.status === 200) {
      return response.json()
    }
  })
};

window.addProduct = async function (items) {
  return await _addGiftProduct(items);
}
/* Remove gift product from cart */

function promotionRootUrl() {
  const root = theme.routes.root_url || '/';
  return root.endsWith('/') ? root : root + '/';
}

_removeGiftProduct = async function(gift_data) {
  // Remove by line key so a paid purchase of the same variant is preserved.
  const updates = {};
  window.cartItemsData.gifts.forEach((gift) => {
    const variantId = Number(gift.variant_id);
    if (gift_data[variantId] === 0 || gift_data[gift.key] === 0 ||
        !window.giftInPromotion.includes(variantId) || gift.gwpAvailable === false) {
      updates[gift.key] = 0;
    }
  });
  if (Object.keys(updates).length === 0) return false;

  const root = promotionRootUrl();
  const response = await fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ updates })
  });
  if (!response.ok) throw new Error('Unable to remove unavailable gifts from the cart.');
  const cart = await response.json();
  if (!Array.isArray(cart.items) || cart.items.some((item) => updates[item.key] === 0)) {
    throw new Error('Gift removal did not update the cart.');
  }
  window.cartItemsData.gifts = window.cartItemsData.gifts.filter((gift) => updates[gift.key] !== 0);
  window.cartItemsData.giftsInCart = [...new Set(window.cartItemsData.gifts.map((gift) => Number(gift.variant_id)))];
  return cart;
};

window.removeProduct = async function (items) {
return await _removeGiftProduct(items)
}

/* Clear cart */

_clearCart = async function() {
  var result = await fetch(promotionRootUrl() + 'cart/clear.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
      }
  })

  if (result.status === 200) {
      window.cart_clear = true;
      return result.json();
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

/* Show/hide error message */

invalidPromotionCode = function(display, container) {
  var containers = container ? [container] : getPromotionContainers();
  if (containers.length === 0) return;
  containers.forEach((containerItem) => {
    var invalidPromocode = containerItem.querySelector("#invalid-discount");
    if (invalidPromocode) invalidPromocode.style.display = display;
  });

}

/* Add discount code */
window.addCodeStack = async function(event) {
  if (event) event.preventDefault();
  var container = getPromotionContainer(event && event.target);
  var promocode = getPromotionInput(container);
  if (!promocode) return;
  if(window.discount.includes(promocode.value.toUpperCase())){
      setPromotionInputState(promocode.value.toUpperCase(), false, false);
      invalidPromotionCode("none", container);
      await window.promotionValidate().then(() => {
        window.refreshCart();
      });
  } else {
      invalidPromotionCode("block", container);
  }
}
/* Remove discount code */

window.removeCodeStack = async function(event) {
  if (event) event.preventDefault();
  setPromotionInputState("", false, false);
  localStorage.removeItem("promocode");
  await window.promotionValidate().then(() => {
    window.refreshCart();
  });
}

/* Clear discount box */

window.clearCodeStack = async function() {
  localStorage.removeItem("promocode");
  setPromotionInputState("", false, false);
  invalidPromotionCode("none");
}

/* Compare lists */

compareArrays = function (promotion = [], promotionArray = [], productCount, type = "", index) {
  if(promotion.operationType == "and") {
      var matched_product1 = [], matched_product2 = [];
      promotionArray.filter(x => {
          if(promotion.productList1.includes(x)) {
              matched_product1.push(x);
          }
          if(promotion.productList2.includes(x) && !matched_product2.includes(x)) {
              matched_product2.push(x);
          }
      })
      // if both list has same product info
      // for example: if same sku is added in both list then quantity should be 2 or greater

      var and_flag = false;
      if (matched_product1.length == 1 && matched_product2.length == 1 && matched_product1[0] == matched_product2[0]) {
          and_flag = window.cartItemsData.productData.some(x => {
              if(type == "sku") return matched_product1.includes(x.sku) && x.quantity >= 2;
              if (type == "type") return matched_product1.includes(x.type) && x.quantity >= promotion.productCount;
              if (type == "product_id") return matched_product1.includes(x.productID) && x.quantity >= 2;
              if (type == "vendor") return matched_product1.includes(x.vendor) && x.quantity >= 2;
              return false;
          });
          if(and_flag) {
              return true;
          }
      } else if (matched_product1.length >= promotion.productCount && matched_product2.length >= 1) {
          //if condition purchase count on the list is 1
          return true;
      } else if( matched_product1.length >= 1 && promotion.productCount >= 2 && matched_product2.length >= 1) {
          //if condition purchase count on the list is 2 or more than 2
          window.cartItemsData.productData.filter(x => {
              if(type == "sku" && matched_product1.includes(x.sku) && x.quantity >= promotion.productCount) {
                  and_flag = true;
              } else if (type == "type" && matched_product1.includes(x.type) && x.quantity >= promotion.productCount) {
                  and_flag = true;
              } else if (type == "product_id" && matched_product1.includes(x.productID) && x.quantity >= 2) {
                  and_flag = true;
              } else if (type == "vendor" && matched_product1.includes(x.vendor) && x.quantity >= 2) {
                  and_flag = true;
              }
              //  else {

              //     and_flag = false;
              // }
          });
          if(and_flag) {
              return true;
          }
      } else {
          return false;
      }
  } else if (type == "excludeProduct") {
      var excluded = false;
      /** InsCoder 2026-07-07 B + Fail closed when a tag exclusion cannot load current cart tags **/
      if(promotion.excludeProductTag && window.cartItemsData.productData.some(data => !data.tagsLoaded)) {
          return false;
      }
      /** InsCoder 2026-07-07 E + Fail closed when a tag exclusion cannot load current cart tags **/
      if(promotion.minimumCartAmount || promotion.maximumCartAmount) { // price of excluded product will not count if minimum amount specified
          var cartTotal = 0, matchFound = false;
          var productData = window.cartItemsData.productData
          var cartItemTotal = window.cartItemsData.cartTotal;
          for(let i = 0; i < productData.length; i++) {
              let data = productData[i];
              var dataType = data.type;
              var dataSku = data.sku;
              var dataTags = Array.isArray(data.tags) ? data.tags : [];
              let itemHasDiscount = false;
              if(promotion.excludeDiscountedProduct && data.discountTitles){
                const discountTitles = data.discountTitles.split(",");
                itemHasDiscount = (promotion.excludeDiscountedProduct.length > 0) ? discountTitles.some(discountTitle => promotion.excludeDiscountedProduct.some(exld => discountTitle?.toLowerCase().includes(exld)) ) : false;
              }
              if(promotion.excludeProduct && dataType !== '' && promotion.excludeProduct.includes(dataType) && !data.hasDiscount) {
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              } else if (promotion.excludeProductSku && dataSku !== '' && promotion.excludeProductSku.includes(dataSku) && !data.hasDiscount){
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              } else if (promotion.excludeProductTag && dataTags.some(tag => promotion.excludeProductTag.includes(tag)) && !data.hasDiscount){
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              } else if (itemHasDiscount){
                  cartItemTotal = cartItemTotal - data.price
                  cartTotal = cartItemTotal;
                  matchFound = true;
              }else {
                window.promotionSettings.gwp[index].includedTotalPrice+= data.price
              }
          }
          if(cartTotal <= 0 && !matchFound) {
              cartTotal = window.cartItemsData.cartTotal;
          }
          if(promotion.minimumCartAmount && !promotion.maximumCartAmount) {
              if(cartTotal >= promotion.minimumCartAmount) {
                  excluded = true;
              }
          } else if (!promotion.minimumCartAmount && promotion.maximumCartAmount) {
              if(cartTotal <= promotion.maximumCartAmount) {
                  excluded = true;
                  if(!promotion.conditionArray.includes("maximumCartAmount")) {
                      promotion.conditionArray.push("maximumCartAmount");
                  }
              }
          } else if(promotion.minimumCartAmount && promotion.maximumCartAmount) {
              if(cartTotal >= promotion.minimumCartAmount && cartTotal <= promotion.maximumCartAmount) {
                  excluded = true;
                  if(!promotion.conditionArray.includes("maximumCartAmount")) {
                      promotion.conditionArray.push("maximumCartAmount");
                  }
              }
          }
      } else {
          window.cartItemsData.productData.filter(x => { // Exclude product type
              let exclude1 = false,exclude2 = false,exclude3 = false,exclude4 = false;
            
              let itemHasDiscount = false;
              if(promotion.excludeDiscountedProduct && x.discountTitles){
                const discountTitles = x.discountTitles.split(",");
                itemHasDiscount = (promotion.excludeDiscountedProduct.length > 0) ? discountTitles.some(discountTitle => promotion.excludeDiscountedProduct.some(exld => discountTitle?.toLowerCase().includes(exld)) ) : false;
              }
            
              if((promotion.excludeProduct && !promotion.excludeProduct.includes(x.type)) || !promotion.excludeProduct ){
                 exclude1 = true
              }
              if((promotion.excludeProductSku && !promotion.excludeProductSku.includes(x.sku)) || !promotion.excludeProductSku ){
                 exclude2 = true
              }
              if((promotion.excludeProductTag && !(Array.isArray(x.tags) && x.tags.some(tag => promotion.excludeProductTag.includes(tag)))) || !promotion.excludeProductTag ){
                 exclude4 = true
              }
              if((promotion.excludeDiscountedProduct && !itemHasDiscount) || !promotion.excludeDiscountedProduct ){
                 exclude3 = true
              }
              if(exclude1 && exclude2 && exclude3 && exclude4) {
                  excluded = true;
                  window.promotionSettings.gwp[index].includedTotalPrice+= x.price
              }
          });
      }
      return excluded ? true : false;
  } else {
      var matched_product = [], quantity_count = 0;

      promotionArray.filter(x => {
          if(promotion.productList1.includes(x)) {
              matched_product.push(x);
          }
      });
      window.cartItemsData.productData.filter(x => {
          if(type == "sku" && matched_product.includes(x.sku)) {
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
            quantity_count = quantity_count + x.quantity;
          } else if (type == "type" && matched_product.includes(x.type)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          } else if (type == "product_id" && matched_product.includes(x.productID)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          } else if (type == "vendor" && matched_product.includes(x.vendor)) {
            quantity_count = quantity_count + x.quantity;
            window.promotionSettings.gwp[index].includedTotalPrice+= x.price
          }
      });

      if(quantity_count >= productCount) {
          return true;
      } else {
          return false;
      }
  }
}

/** InsCoder 2026-07-07 B + Load current cart product tags for GWP exclusions **/
_getCartProductTags = async function () {
  const rootUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.root_url)
    ? theme.routes.root_url
    : '/';
  const separator = rootUrl.includes('?') ? '&' : '?';
  const result = await fetch(`${rootUrl}${separator}section_id=helper-cart-progress-bar`, {
    headers: {
      "Accept": "text/html"
    },
    cache: "no-store"
  });

  if (!result.ok) {
    return null;
  }

  const html = await result.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const productTagsJson = doc.querySelector('[data-gwp-cart-product-tags]');
  if (!productTagsJson || !productTagsJson.textContent.trim()) {
    return null;
  }

  try {
    const lineStatesJson = doc.querySelector('[data-gwp-cart-line-states]');
    return {
      productTags: JSON.parse(productTagsJson.textContent),
      lineStates: lineStatesJson ? JSON.parse(lineStatesJson.textContent) : {}
    };
  } catch (error) {
    console.warn('Unable to parse GWP cart product tags.', error);
    return null;
  }
}
/** InsCoder 2026-07-07 E + Load current cart product tags for GWP exclusions **/

// The pre-marker Striped ankle socks promotion used this retail variant.
// Only free lines qualify for migration; paid purchases must remain untouched.
const legacyGwpVariantIds = new Set([44582672302125]);

async function getGiftAvailability() {
  const gifts = (window.promotionSettings?.gwp || []).flatMap((promotion) => promotion.gifts || []);
  const handles = [...new Set(gifts.map((gift) => gift.handle).filter(Boolean))];
  const availability = {};
  await Promise.all(handles.map(async (handle) => {
    try {
      const response = await fetch(promotionRootUrl() + 'products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store' });
      if (response.status === 404) {
        gifts.filter((gift) => gift.handle === handle).forEach((gift) => { availability[gift.id] = false; });
      } else if (response.ok) {
        const product = await response.json();
        if (!Array.isArray(product.variants)) return;
        gifts.filter((gift) => gift.handle === handle).forEach((gift) => {
          availability[gift.id] = product.variants.find((variant) => Number(variant.id) === Number(gift.id))?.available === true;
        });
      }
    } catch (error) {
      console.warn('Unable to check gift availability.', error);
    }
  }));
  return availability;
}

/* Get product from cart */

_getCart = async function () {
  const cartRequest = fetch(theme.routes.cart_url + '.js', {
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      }
  });
  const productTagsRequest = _getCartProductTags().catch(() => null);
  const [result, promotionData, availability] = await Promise.all([cartRequest, productTagsRequest, getGiftAvailability()]);

  if (result.status === 200) {
    const cart = await result.json();
    cart.productTagsByLineKey = promotionData?.productTags || {};
    cart.productTagsLoaded = promotionData !== null;
    cart.lineStatesByKey = promotionData?.lineStates || {};
    cart.giftAvailabilityByVariantId = availability;
    return cart;
  }

  throw new Error(`Failed to get request, API returned ${result.status} ${result.statusText}`);
}

window.progressBar = function (elem = document) {
  if (!elem || !elem.querySelector || !elem.querySelector('.price-progress-bar .meter')) { return false; }
  if (!window.cartItemsData || !window.promotionSettings || !window.promotionSettings.gwp) { return false; }
  var progressBarContainer = elem.querySelector('.price-progress-bar');
  /* price-progress-bar guard */
  var gwpList = window.promotionSettings.gwp, 
    priceLists = [],
    remainingAmountHTML = "",
    include_total_price = 0,
    total_price = 0,
    totalTiers = [],
    tierCount = 1,
    total_value_set_price = 0;
  let cartTotalValue = window.cartItemsData && window.cartItemsData.cartTotal ? window.cartItemsData.cartTotal:0;
  let promotionCodeRules = [];
  for(let i = 0; i < gwpList.length; i++) {
    // updated includedTotalPrice, when discount text is match from the theme settings
    gwpList[i].includedTotalPrice_progress = gwpList[i].includedTotalPrice

    let promotion = gwpList[i];
    if(promotion.excludeProduct !== false || promotion.excludeProductSku !== false || promotion.excludeProductTag !== false || promotion.excludeDiscountedProduct !== false) {
     include_total_price = promotion.includedTotalPrice_progress;
    }
    let show_process = promotion.match_tag;
    let excluded_skus_str = [],excluded_product_skus_str = [];
    if(promotion.excludeByGwpSku){
      excluded_skus_str = normalizeRuleList(promotion.excludeByGwpSku, true);
      
      gwpList.forEach(p => {
        let is_exclude = false
        p.gifts.map(item => item && item.sku ? item.sku.toLowerCase() : '').forEach(sku => {
          if(sku && excluded_skus_str.includes(sku)){
            is_exclude = true
          }
        })
        if(!p.code && !p.minimumCartAmount && p.conditionType == "any_purchase" && p.match_tag && is_exclude) {
          show_process = false
        }else if(!p.code && p.minimumCartAmount && p.match_tag  && is_exclude ) {
          show_process = false
        }
      });
    }
    if(promotion.excludeByProductSku){
      excluded_product_skus_str = normalizeRuleList(promotion.excludeByProductSku, true);
      window.cartItemsData.productData.forEach(product => {
        let is_exclude = false
        if(product.sku && excluded_product_skus_str.includes(product.sku.toLowerCase())){
          is_exclude = true
        }
        if(!promotion.code && !promotion.minimumCartAmount && promotion.conditionType == "any_purchase" && promotion.match_tag && is_exclude) {
          show_process = false
        }else if(!promotion.code && promotion.minimumCartAmount && promotion.match_tag  && is_exclude ) {
          show_process = false
        }
      })
    }
    if(!promotion.code && !promotion.minimumCartAmount && promotion.conditionType == "any_purchase" && show_process ) {
      //automatic gift
      if(promotion.gifts && promotion.gifts.length > 0) {
        priceLists.push({price: 0, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
        totalTiers.push({tier: tierCount, minimumCartAmount: (!promotion.minimumCartAmount) ? 0 : promotion.minimumCartAmount,title: arrayToEnWords(promotion.gifts), promotion: promotion });
        tierCount++;
      }
    }else if(!promotion.code && promotion.minimumCartAmount && show_process) {
      if(promotion.gifts[0] && promotion.gifts[0].title) {
        priceLists.push({price: promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
        totalTiers.push({tier: tierCount, minimumCartAmount: (!promotion.minimumCartAmount) ? 0 : promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), promotion: promotion });
        tierCount++;
      }
      
    } else if(promotion.code && promotion.gifts[0]) {
        promotionCodeRules.push({price: promotion.minimumCartAmount, title: arrayToEnWords(promotion.gifts), maxPrice: promotion.maximumCartAmount ? promotion.maximumCartAmount : 0, minPrice: promotion.minimumCartAmount ? promotion.minimumCartAmount : 0, promotion: promotion})
    }
  }
  /* If no visible tiers are applicable for current visitor/cart, hide empty progress bar shell. */
  if (progressBarContainer && totalTiers.length === 0 && promotionCodeRules.length === 0) {
    progressBarContainer.style.display = 'none';
    return false;
  }
  if (progressBarContainer) {
    progressBarContainer.style.display = '';
  }
  // for(let i = 0; i < window.cartItemsData.productData.length; i++) {
  //   let variant = window.cartItemsData.productData[i];
  //   if(variant.type != "value set") {
  //     total_price = total_price + variant.price;
  //   } else {
  //     total_value_set_price = total_value_set_price + variant.price;
  //   }
  // }
  var tick =`<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.85686 0.375H6.01504C5.83195 0.375 5.65785 0.455901 5.55015 0.59459L2.72852 4.19388L1.45053 2.56264C1.34283 2.42561 1.17052 2.34305 0.985643 2.34305H0.143822C0.0271513 2.34305 -0.041056 2.46523 0.0271513 2.55274L2.26363 5.40575C2.31647 5.47358 2.38612 5.52885 2.46681 5.56698C2.5475 5.60511 2.63691 5.625 2.72762 5.625C2.81834 5.625 2.90775 5.60511 2.98844 5.56698C3.06913 5.52885 3.13878 5.47358 3.19161 5.40575L6.97173 0.584684C7.04174 0.497178 6.97353 0.375 6.85686 0.375Z" fill="white"/>
    </svg>`;
  var message1Counter = 0, message2Counter = 0, currentPromoPrice = 0, fullfilledTier = 0, unFullfilledTier = 0;
  let codeUsed = localStorage.getItem("promocode");
  for(let index = 0; index < priceLists.length; index++) {
    let priceList = priceLists[index];
    var price = priceList.price, title = priceList.title;
    if(priceList.promotion.operationType != "and" && priceList.promotion.conditionType != "sku") {
        if(promotionCodeRules.length > 0 && codeUsed != null) {
          for(let ind = 0; ind < promotionCodeRules.length; ind++) {
            let pr = promotionCodeRules[ind]
            if((cartTotalValue >= pr.price && pr.promotion.code && pr.promotion.code.split(", ").includes(codeUsed)) || (pr.price == false && pr.promotion.code && pr.promotion.code.split(", ").includes(codeUsed))){
              let mess = '<li class="price-indicatiors">'+_promoStr('thankYouCode')+'<b>'+codeUsed+'</b>! <p style="display: inline">'+_promoStr('eligible')+'</p> <span class="gift-title">'+pr.title+'</span>!</li>';
              if(remainingAmountHTML.indexOf(mess) == -1) {
                remainingAmountHTML = remainingAmountHTML + mess;
              }
            }
          }
        }
    }
  }
  if(elem.querySelector(".price-progress-bar .remaining-amount")){
    elem.querySelector(".price-progress-bar .remaining-amount").innerHTML = remainingAmountHTML;
  }
  let promotionSettings = window.promotionSettings.gwp;
  include_total_price = cartTotalValue;
  promotionSettings.forEach((e) => {
    if (Number.isFinite(e.includedTotalPrice_progress)) {
      include_total_price = Math.max(include_total_price, e.includedTotalPrice_progress);
    }
  })
  let progressBar = elem.querySelector(".price-progress-bar .meter")
  let tierLength = totalTiers.length - 1;
  let maxTierPrice = ( totalTiers[tierLength] && totalTiers[tierLength].minimumCartAmount) ? totalTiers[tierLength].minimumCartAmount : 0;
  let currentCartTotal = include_total_price;
  
  let markerPosition = 0, fulfilledTier = 0;
  const maxVisualPercent = totalTiers.length === 1 ? 99 : 96;
  const clampPercent = function (value) {
    if (!Number.isFinite(value)) return 0;
    return Math.max(0, Math.min(100, value));
  };
  let liTierHTML = "";
  elem.querySelector(".price-progress-bar .remaining-amount").innerHTML = "";
  elem.querySelector(".price-progress-bar .data-markers").innerHTML = "";
  totalTiers.forEach((t) => {
    // for tier marker
    let spanTier = document.createElement("span");
    markerPosition = maxTierPrice > 0 ? ((t.minimumCartAmount / maxTierPrice) * 100) : 0;
    spanTier.innerText = t.tier ;
    markerPosition = (markerPosition >= maxVisualPercent) ? maxVisualPercent : markerPosition;
    spanTier.style.left = markerPosition + '%';
    markerPosition+= markerPosition;
    if(markerPosition >= 100) {
      markerPosition = 100;
    }
    // for tier message
    let liTier = '';
    const isGuestLockedTier = !!(t.promotion && t.promotion.isLoggedIn && !(window.theme && window.theme.isLoggedIn));
    const loginUnlockMessage = isGuestLockedTier ? (' ' + _promoStr('loginToUnlock')) : '';
    if(window.cartItemsData.giftsInCart.length == 0 || window.cartItemsData.productData.length == 0) {
     if(t.promotion.conditionType == "any_purchase" && !t.promotion.minimumCartAmount) {
       liTier = '<li class="price-indicatiors" data-price-indicatiors-1>'+_promoStr('addAny')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
       spanTier.style.left = '0';
       spanTier.setAttribute("data-fulfill", false);
     } else {
      let computedRemaining = t.minimumCartAmount;
       if(window.cartItemsData.productData.length > 0) {
        computedRemaining = t.minimumCartAmount - t.promotion.includedTotalPrice_progress;
       }
      computedRemaining = Math.max(0, computedRemaining);
      var computedRemainingFormatted = _formatPromotionMoney(computedRemaining);
       if (isGuestLockedTier && window.cartItemsData.productData.length > 0 && t.promotion.includedTotalPrice_progress >= t.minimumCartAmount) {
        liTier = '<li class="price-indicatiors" data-price-indicatiors-4">'+_promoStr('congratulations')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
        spanTier.setAttribute("data-fulfill", true);
       } else {
        liTier = '<li class="price-indicatiors" data-price-indicatiors-2">'+_promoStr('spend')+'<span class="price">'+computedRemainingFormatted+'</span>'+_promoStr('more')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
        spanTier.setAttribute("data-fulfill", false);
      }
       fulfilledTier = t.promotion.includedTotalPrice_progress;
     }
    } else {
     if(t.minimumCartAmount == 0 && currentCartTotal == 0) {
       liTier = '<li class="price-indicatiors" data-price-indicatiors-3">'+_promoStr('addAny')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
       spanTier.style.left = '0';
       spanTier.setAttribute("data-fulfill", false);
     }
     else if(t.promotion.includedTotalPrice_progress >= t.minimumCartAmount ) {
      liTier = '<li class="price-indicatiors" data-price-indicatiors-4">'+_promoStr('congratulations')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
       spanTier.setAttribute("data-fulfill", true);
       fulfilledTier = t.promotion.includedTotalPrice_progress;
     } else {
      var computedRemainingTier = Math.max(0, (t.minimumCartAmount - t.promotion.includedTotalPrice_progress));
      liTier = '<li class="price-indicatiors" data-price-indicatiors-5">'+_promoStr('spend')+'<span class="price">'+_formatPromotionMoney(computedRemainingTier)+'</span>'+_promoStr('more')+'<span class="gift-title">'+t.title+'</span>!'+loginUnlockMessage+'</li>';
       spanTier.setAttribute("data-fulfill", false);
     }
    }
    
    let progressBarMarker = maxTierPrice > 0 ? Math.round((fulfilledTier / maxTierPrice) * 100 ) : 0;
    if(window.cartItemsData.giftsInCart.length > 0 && window.cartItemsData.productData.length > 0) {
      if(progressBarMarker >= maxVisualPercent) {
        progressBar.querySelector("[data-meter]").style.width = maxVisualPercent + "%";
      } else {
        const fulfilledPercent = maxTierPrice > 0 ? Math.round((fulfilledTier / maxTierPrice) * 100 ) : 0;
        progressBar.querySelector("[data-meter]").style.width = clampPercent(fulfilledPercent)+"%";
      }
    } else if(window.cartItemsData.productData.length == 0) {
      progressBar.querySelector("[data-meter]").style.width = "0%";
    } else {
      if(t.promotion.minimumCartAmount > 0) {
        progressBar.querySelector("[data-meter]").style.width = clampPercent(Math.round((fulfilledTier / t.promotion.minimumCartAmount) * 100 ))+"%";
      } else {
        progressBar.querySelector("[data-meter]").style.width = "0%";
      }
    }
    progressBar.querySelector(".data-markers").appendChild(spanTier);
    liTierHTML += liTier;
  });
  elem.querySelector(".price-progress-bar .remaining-amount").innerHTML = liTierHTML + remainingAmountHTML;
  return true;
}

window.promotionValidate = async function () {
  if (!window.promotionSettings || !window.promotionSettings.gwp) { return Promise.resolve(); }
  window.__cartNeedsPromotionRefresh = true;

  document.querySelector(".cart-loading-overlay")?.removeAttribute("style");
  var alreadyAppliedGift = [];
  window.cart_clear = false;
  var promocodeValue = getPromotionInputValue();
  let excludeDiscountedProduct = (window.excludeDiscountedProduct) ? window.excludeDiscountedProduct?.toLowerCase().split(', ') : "";

  await _getCart().then(async function(response) {
      /* store cart items data in window object */
      if(response) {
          window.cartItemsData = [];
          window.cartItemsData.productData = [];
          window.cartItemsData.productSku = [];
          window.cartItemsData.productID = [];
          window.cartItemsData.productType = [];
          window.cartItemsData.productVendor = [];
          window.cartItemsData.giftsInCart = [];
          window.cartItemsData.gifts = [];
          window.cartItemsData.giftsInCartWithQuantity = [];
          window.cartItemsData.cartTotal = 0;
          /* Variant IDs configured as GWP gifts — must count as gifts even if product_type in admin is not "gift" */
          var configuredGiftVariantIds = new Set();
          if (window.promotionSettings && window.promotionSettings.gwp) {
            window.promotionSettings.gwp.forEach(function (promo) {
              (promo.gifts || []).forEach(function (g) {
                if (g && g.id != null) configuredGiftVariantIds.add(Number(g.id));
              });
            });
          }
          for(let i = 0; i < response['items'].length; i++) {
              let item = response['items'][i];
              // check each cart item for discount | default: false
              let itemHasDiscount = (excludeDiscountedProduct.length > 0) ? item?.discounts.some(cartItem => excludeDiscountedProduct.some(exld => cartItem.title?.toLowerCase().includes(exld)) ) : false;

              var lineVariantId = item.variant_id != null ? Number(item.variant_id) : null;
              const tags = normalizeRuleList(response.productTagsByLineKey?.[item.key] || [], true);
              const linePrice = Number(item.final_line_price ?? item.line_price);
              const isFree = Number.isFinite(linePrice) && linePrice === 0;
              var isGiftLine = item.properties?._gwp === 'true' || (isFree && (
                String(item.product_type).toLowerCase() === 'gift' || tags.includes('99 dummy / gift') ||
                configuredGiftVariantIds.has(lineVariantId) || legacyGwpVariantIds.has(lineVariantId)
              ));

              if(!isGiftLine) {
                  window.cartItemsData.productData.push({
                      id: item.id,
                      productID: item.product_id.toString(),
                      sku: item.sku,
                      vendor: item.vendor.toLowerCase(),
                      quantity: item.quantity,
                      price: (item.line_price / 100),
                      title: item.title,
                      discountTitle: (item?.discounts.length) ? item?.discounts[0].title : '',
                      type: item.product_type.toLowerCase(),
                      /** InsCoder 2026-07-07 B + Product tags used by GWP exclusion rules **/
                      tags: normalizeRuleList(response.productTagsByLineKey?.[item.key] || [], true),
                      tagsLoaded: response.productTagsLoaded && Object.prototype.hasOwnProperty.call(response.productTagsByLineKey, item.key),
                      /** InsCoder 2026-07-07 E + Product tags used by GWP exclusion rules **/
                      hasDiscount: itemHasDiscount,
                      discountTitles: (item?.discounts.length) ? item?.discounts.map(temp => temp.title).join(",") : '',
                  })
                  window.cartItemsData.productSku.push(item.sku)
                  window.cartItemsData.productID.push(item.product_id.toString())
                  window.cartItemsData.productType.push(item.product_type.toLowerCase())
                  window.cartItemsData.productVendor.push(item.vendor.toLowerCase())
              } else {
                  item.gwpAvailable = response.giftAvailabilityByVariantId?.[lineVariantId] ?? response.lineStatesByKey?.[item.key]?.available;
                  /* giftsInCart stores variant_id (matches promotion gift.id), dedupe if same variant multiple lines */
                  if (lineVariantId != null && !window.cartItemsData.giftsInCart.includes(lineVariantId)) {
                    window.cartItemsData.giftsInCart.push(lineVariantId);
                  }
                  window.cartItemsData.gifts.push(item);
                  window.cartItemsData.giftsInCartWithQuantity.push({id: lineVariantId, quantity: item.quantity});
              }
          }
          // Sum the prices of items with a discount, where hasDiscount is true,
          // to exclude them from the promotion GWP calculation.
          let excludeAmountFromGWPComputation = window.cartItemsData?.productData.filter((item) => item?.hasDiscount).reduce((acc, item) => acc + item.price, 0) || 0;
          // set the cart total
          let totalPrice = response.total_price / 100;
          // updated the cartTotal price
          const giftAmount = window.cartItemsData.gifts.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price) / 100, 0);
          window.cartItemsData.cartTotal = totalPrice - giftAmount - excludeAmountFromGWPComputation;
          window.__cartItemsDataUpdatedAt = Date.now();
      }

      var excluded_skus = [], excluded_product_skus = [];

      
      var gwpList = window.promotionSettings.gwp,
          giftToAdd = [], // gift will add to cart
          giftToRemove = {}, // gift will remove from cart
          conditionArray = [],
          randomGifts = [],
          clearCart = false,
          appliedCode = promocodeValue ? promocodeValue.toUpperCase() : "false";
      /* Fatch products from local storage which randomly applied in cart */

      if(localStorage.getItem('randomGifts')) {
          randomGifts = JSON.parse(localStorage.getItem('randomGifts'));
      }
      window.giftInPromotion = [];
      for (let i = 0; i < gwpList.length; i++) {  
        let promotion = gwpList[i];
        promotion.gifts = (promotion.gifts || []).filter((gift) => gift && gift.id != null);
        for (let i = 0; i < promotion.gifts.length; i++) {
          let gift = promotion.gifts[i];
          // Never use page-load inventory for a later add or cleanup decision.
          gift.available = response.giftAvailabilityByVariantId?.[gift.id];
          if (gift && gift.id != null) window.giftInPromotion.push(Number(gift.id));
        }
      }

      /* conditions will check if cart has any non-gift products */
      if(window.cartItemsData.productData.length > 0) {
        for (let i = 0; i < gwpList.length; i++) {
            window.promotionSettings.gwp[i].includedTotalPrice = 0;
            let promotion = gwpList[i];
            
            /* create an array of an options which is enabled in theme settings: start */
            
            if(promotion.minimumCartAmount != false) {
                conditionArray.push("minimumCartAmount");
            }
            if(promotion.maximumCartAmount != false) {
                conditionArray.push("maximumCartAmount");
            }
            if(promotion.excludeProduct != false || promotion.excludeProductSku != false || promotion.excludeProductTag != false || promotion.excludeDiscountedProduct != false) {
                conditionArray.push("excludeProduct");
            }
            if(promotion.isNewCustomer != false) {
                conditionArray.push("isNewCustomer");
            }
            if(promotion.isLoggedIn != false) {
                conditionArray.push("isLoggedIn");
            }
            if(promotion.code != false) {
                conditionArray.push("code");
            }

            /* create an array of an options which is enabled in theme settings : end */

            /* check conditions and create an array of an options fulfilled in cart : start */

            if (promotion.excludeProduct) {
                promotion.excludeProduct = normalizeRuleList(promotion.excludeProduct, true);
            }
            if (promotion.excludeProductSku) {
                promotion.excludeProductSku = normalizeRuleList(promotion.excludeProductSku, true);
            }
            if (promotion.excludeProductTag) {
                promotion.excludeProductTag = normalizeRuleList(promotion.excludeProductTag, true);
            }
            if (promotion.excludeDiscountedProduct) {
                promotion.excludeDiscountedProduct = normalizeRuleList(promotion.excludeDiscountedProduct, true);
            }
            if (promotion.productList1) {
                promotion.productList1 = normalizeRuleList(promotion.productList1, false);
            }
            if (promotion.productList2) {
                promotion.productList2 = normalizeRuleList(promotion.productList2, false);
            }

            if(promotion.conditionType != false) {
                conditionArray.push(promotion.conditionType);
            }
            if(appliedCode &&
                promotion.code != false &&
                promotion.code.split(", ").includes(appliedCode) &&
                !promotion.conditionArray.includes("code")) {
                promotion.conditionArray.push("code");
            }
            if(promotion.minimumCartAmount && window.cartItemsData.cartTotal >= Number(promotion.minimumCartAmount) && !promotion.conditionArray.includes("minimumCartAmount")) {
                promotion.conditionArray.push("minimumCartAmount");
            }
            if(promotion.maximumCartAmount && window.cartItemsData.cartTotal <= Number(promotion.maximumCartAmount) && !promotion.conditionArray.includes("maximumCartAmount")) {
                promotion.conditionArray.push("maximumCartAmount");
            }
            if(promotion.conditionType != "any_purchase") {
                if(!promotion.productCount) {
                    promotion.productCount = 1;
                }
                if(promotion.conditionType == "sku") {
                    if(compareArrays(promotion, window.cartItemsData.productSku, promotion.productCount, "sku", i) && !promotion.conditionArray.includes("sku")) {
                        promotion.conditionArray.push("sku");
                    }
                }
                if(promotion.conditionType == "type") {
                    if(compareArrays(promotion, window.cartItemsData.productType, promotion.productCount, "type", i) && !promotion.conditionArray.includes("type")) {
                        promotion.conditionArray.push("type");
                    }
                }
                if(promotion.conditionType == "product_id") {
                    if(compareArrays(promotion, window.cartItemsData.productID, promotion.productCount, "product_id", i) && !promotion.conditionArray.includes("product_id")) {
                        promotion.conditionArray.push("product_id");
                    }
                }
                if(promotion.conditionType == "vendor") {
                    if(compareArrays(promotion, window.cartItemsData.productVendor, promotion.productCount, "vendor", i) && !promotion.conditionArray.includes("vendor")) {
                        promotion.conditionArray.push("vendor");
                    }
                }
            } else {
                if(!promotion.excludeProduct && !promotion.excludeProductSku && !promotion.excludeProductTag && !promotion.excludeDiscountedProduct) {
                  window.promotionSettings.gwp[i].includedTotalPrice = window.cartItemsData.cartTotal;
                }
                if(!promotion.conditionArray.includes("any_purchase")) {
                    promotion.conditionArray.push("any_purchase");
                }
            }
            if(promotion.excludeProduct || promotion.excludeProductSku || promotion.excludeProductTag || promotion.excludeDiscountedProduct) {
              var remaining_price = compareArrays(promotion, window.cartItemsData.productType, "", "excludeProduct", i);
              if(remaining_price && !promotion.conditionArray.includes("excludeProduct")) {
                  promotion.conditionArray.push("excludeProduct");
              }
            }
            if(promotion.isNewCustomer && window.theme.isLoggedIn && window.theme.customerSpent == 0 && !promotion.conditionArray.includes("isNewCustomer")) {
                promotion.conditionArray.push("isNewCustomer");
            }
            if(promotion.isLoggedIn && window.theme.isLoggedIn && !promotion.conditionArray.includes("isLoggedIn")) {
                promotion.conditionArray.push("isLoggedIn");
            }

            /* check conditions and create an array of an options fulfilled in cart : end */

            /* Compare both arrays (all options in cart and fulfilled option) */
            if(conditionArray.length == promotion.conditionArray.length) {
                promotion.isCriteriaMeet = true;
            }

            /* create an arrays for add and remove gifts: start */
            var promotionMatchCodes = promotion.match_codes || [];
            if(promotion.isCriteriaMeet && promotion.match_tag  && (promotionMatchCodes.length == 0 || (promotion.code && promotionMatchCodes.includes(appliedCode)) || !promotion.code)) {
                if(promotion.code && promotion.code.split(", ").includes(appliedCode) && appliedCode != "") {
                    invalidPromotionCode("none");
                    localStorage.setItem("promocode", appliedCode);
                    setPromotionInputState(appliedCode, true, true);
                }
                if(!promotion.isRandomGift) {
                  for (let i = 0; i < promotion.gifts.length; i++) {
                    let gift = promotion.gifts[i];
                    if(gift && gift.available && promotion.excludeByGwpSku){
                      promotion.excludeByGwpSku.split(",").forEach(item => {
                        excluded_skus.push({"sku": item, "id": gift.id})
                      })
                    }
                    if(gift && gift.available && promotion.excludeByProductSku){
                      promotion.excludeByProductSku.split(",").forEach(item => {
                        excluded_product_skus.push({"sku": item, "id": gift.id})
                      })
                    }
                    if(gift && gift.available && !window.cartItemsData.giftsInCart.includes(Number(gift.id))) {
                      if(gift.item_sku){
                        giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'_gwp': 'true', 'Item SKU': gift.item_sku}});
                      }else{
                        giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'_gwp': 'true'}});
                      }
                    }
                  }
                } else {

                    /* select one gift product from 3 to apply randomly */

                    var availableGifts = [];
                    
                    for (let i = 0; i < promotion.gifts.length; i++) {
                        let gift = promotion.gifts[i];
                        if(gift && gift.available) {
                            availableGifts.push(gift);
                        }
                    }

                    // collect all randomly applied gift products
                    alreadyAppliedGift = availableGifts.filter(value => randomGifts.includes(value.id));

                    if(availableGifts.length > 0 && alreadyAppliedGift.length == 0) { // check gift product is already applied to the cart or not
                        var random_number = availableGifts.length > 1 ? Math.floor(Math.random() * availableGifts.length) : 0;
                        for (let index = 0; index < availableGifts.length; index++) {
                            if(random_number == index) {
                                let gift = availableGifts[index];
                                if(gift && gift.available && promotion.excludeByGwpSku){
                                  normalizeRuleList(promotion.excludeByGwpSku, true).forEach(item => {
                                    excluded_skus.push({"sku": item, "id": gift.id})
                                  })
                                }
                                if(gift && gift.available && promotion.excludeByProductSku){
                                  normalizeRuleList(promotion.excludeByProductSku, true).forEach(item => {
                                    excluded_product_skus.push({"sku": item, "id": gift.id})
                                  })
                                }
                                if(!window.cartItemsData.giftsInCart.includes(Number(gift.id))) { // if gift item is not added to cart
                                    if(gift.item_sku){
                                      giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'_gwp': 'true', 'Item SKU': gift.item_sku}});
                                    }else{
                                      giftToAdd.push({id: gift.id, quantity: 1, sku: gift.sku, properties: {'_gwp': 'true'}});
                                    }
                                    randomGifts.push(gift.id);
                                    localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                                }
                            } else {
                              let otherGift = availableGifts[index];
                              if(otherGift && window.cartItemsData.giftsInCart.includes(Number(otherGift.id))) {
                                giftToRemove[otherGift.id] = 0;
                              }
                            }
                        }
                    }
                }
            } else {
              if(promotion.code && promotion.code.split(", ").includes(appliedCode) && appliedCode != "") { // promotion code is valid but not fulfill requirement
                    invalidPromotionCode("block");
                }
                for (let i = 0; i < promotion.gifts.length; i++) {
                    let gift = promotion.gifts[i];
                    // remove rendomly added gift
                    if(randomGifts.includes(gift.id)) {
                        var index = randomGifts.indexOf(gift.id)
                        randomGifts.splice(index, 1);
                        localStorage.setItem("randomGifts", JSON.stringify(randomGifts));
                    }
                    if(gift != false && window.cartItemsData.giftsInCart.includes(Number(gift.id))) {
                        giftToRemove[gift.id] = 0;

                        // remove promotion code and hide error
                        if(promotion.code) {
                            localStorage.removeItem("promocode");
                            window.clearCodeStack();
                            invalidPromotionCode("none");
                        }
                    }
                }
            }

          

            /* create an arrays for add and remove gifts: end */
            conditionArray = [];
            promotion.isCriteriaMeet = false;
            promotion.conditionArray = [];
        
        }

        if(excluded_skus.length > 0){
          window.cartItemsData.gifts.forEach(gift => {
            excluded_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == (gift.sku || '').toLowerCase()){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
          giftToAdd.forEach(gift => {
            excluded_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == (gift.sku || '').toLowerCase()){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
        }

        if(excluded_product_skus.length > 0){
          window.cartItemsData.productData.forEach(gift => {
            excluded_product_skus.forEach(excluded_sku => {
              if(excluded_sku.sku == (gift.sku || '').toLowerCase()){
                giftToRemove[excluded_sku.id] = 0
              }
            })
          })
        }

        /* add/remove gifts from the cart */
        var removeProduct = await _removeGiftProduct(giftToRemove), addProduct = await _addGiftProduct(giftToAdd);
      
        //document.dispatchEvent(new CustomEvent('cart:rerender'));

        if(removeProduct || addProduct) {
          if(addProduct && addProduct.items) {
            addProduct.items.forEach((item) => {
              var vid = item.variant_id != null ? Number(item.variant_id) : null;
              if (vid != null && !window.cartItemsData.giftsInCart.includes(vid)) {
                window.cartItemsData.giftsInCart.push(vid);
              }
            });
          }
          return true;
        } else {
          return false;
        }
      } else {

        /* If cart has not include any main product all gift removed from cart */

        if (window.cartItemsData.gifts.length === 0) {
          localStorage.removeItem("randomGifts");
          window.clearCodeStack();
          return false;
        }
        clearCart = await _clearCart();
        if(clearCart.items.length == 0) {
          localStorage.removeItem("randomGifts");
          window.clearCodeStack();
          //document.dispatchEvent(new CustomEvent('cart:rerender'));
          return true;
        }
      }
  })
  .then((didMutateCart) => {
    var miniCartForm = document.querySelector('#mini-cart form#cart.mini-cart, form.mini-cart#cart');
    if (miniCartForm && window.cartItemsData) {
      if (window.cartItemsData.productData && window.cartItemsData.productData.length > 0) {
        miniCartForm.classList.remove('is-empty');
      } else {
        miniCartForm.classList.add('is-empty');
      }
    }
    if (didMutateCart) {
      return window.refreshCart();
    }
    return Promise.resolve();
  })
  .finally(()=> {
    window.__cartNeedsPromotionRefresh = false;
    if (typeof window.renderCartProgressBar === 'function') {
      window.renderCartProgressBar();
    }
    return true;
  });
}


document.addEventListener('click', function (e) {
  var applyBtn = e.target.closest('#discount_apply');
  if (applyBtn && window.addCodeStack) {
    window.addCodeStack(e);
  }
  var closeBtn = e.target.closest('.discount-code-input-close');
  if (closeBtn && window.removeCodeStack) {
    window.removeCodeStack();
  }
});
document.addEventListener('submit', function (e) {
  var promoForm = e.target.closest('.gwp-promocode__form');
  if (promoForm && window.addCodeStack) {
    window.addCodeStack(e);
  }
});
(function () {
  var debounceTimer;
  var promotionValidateInFlight = false;
  var shouldRunPromotionValidateAgain = false;
  var validatePromotions = window.promotionValidate;
  var checkoutPending = false;
  var approvedForms = new WeakSet();
  window.__promotionValidateInFlight = false;
  window.__promotionValidatePromise = null;
  function runPromotionValidateSafely() {
    if (promotionValidateInFlight) {
      shouldRunPromotionValidateAgain = true;
      return window.__promotionValidatePromise || Promise.resolve();
    }
    promotionValidateInFlight = true;
    window.__promotionValidateInFlight = true;
    window.__promotionValidatePromise = (async function () {
      do {
        shouldRunPromotionValidateAgain = false;
        await validatePromotions();
      } while (shouldRunPromotionValidateAgain);
    })()
      .finally(function () {
        promotionValidateInFlight = false;
        window.__promotionValidateInFlight = false;
      });
    return window.__promotionValidatePromise;
  }
  function debouncedPromotionValidate(eventData) {
    var delay = 450;
    if (eventData && eventData.source === 'product-form') {
      delay = 0;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (typeof window.promotionValidate !== 'function') return;
      if (!window.autoPromotionsEnable && !window.enablePromotionsUsingCode) return;
      runPromotionValidateSafely().catch(function (error) { console.warn('Unable to refresh cart promotions.', error); });
    }, delay);
  }
  // All entry points share one queue, including initial load and checkout.
  window.promotionValidate = runPromotionValidateSafely;

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (form?.id !== 'cart' || event.submitter?.name !== 'checkout') return;
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }
    if (!window.autoPromotionsEnable && !window.enablePromotionsUsingCode) return;
    event.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    clearTimeout(debounceTimer);
    var submitter = event.submitter;
    var isDrawer = form.classList.contains('mini-cart');
    submitter.disabled = true;
    try {
      // Quantity requests may still be queued when the buyer clicks checkout.
      var pendingCartUpdates;
      do {
        pendingCartUpdates = Array.from(document.querySelectorAll('cart-items')).filter(function (items) {
          return items.updating && items.updateComplete;
        });
        await Promise.all(pendingCartUpdates.map(function (items) { return items.updateComplete; }));
      } while (pendingCartUpdates.length > 0);
      await runPromotionValidateSafely();
      // Section rendering may have replaced both the form and its button.
      var currentForm = form.isConnected ? form : document.querySelector(isDrawer ? 'form.mini-cart#cart' : 'form#cart:not(.mini-cart)');
      var currentButton = Array.from(document.querySelectorAll('[name="checkout"]')).find(function (button) {
        return button.form === currentForm;
      });
      if (!currentForm || !currentButton) throw new Error('Checkout form is no longer available.');
      currentButton.disabled = false;
      approvedForms.add(currentForm);
      // Quantities are already saved by Ajax. A stale section must not post
      // positional updates[] against the newly cleaned/reordered server cart.
      var omitSavedQuantities = function (formEvent) { formEvent.formData.delete('updates[]'); };
      currentForm.addEventListener('formdata', omitSavedQuantities);
      try {
        currentForm.requestSubmit(currentButton);
      } finally {
        approvedForms.delete(currentForm);
        currentForm.removeEventListener('formdata', omitSavedQuantities);
      }
    } catch (error) {
      console.warn('Cart gift cleanup did not complete before checkout.', error);
      var errorElement = document.querySelector('#cart-errors, #CartStatus');
      if (errorElement) errorElement.textContent = theme.cartStrings.error;
    } finally {
      checkoutPending = false;
      if (submitter.isConnected) submitter.disabled = false;
    }
  }, true);
  document.addEventListener('cart:updated', debouncedPromotionValidate);
  document.addEventListener('ajaxProduct:added', debouncedPromotionValidate);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedPromotionValidate);
  }
})();

let arrayToEnWords = function (array) {
  //map object key title only
  array = array.map(function (item) {
    return `<b>${item.title}</b>`;
  });
  let lastWord = array.pop();
  if (array.length > 0) {
    return array.join(", ") +`${_promoStr('andWord')}`+ lastWord;
  } else {
    return lastWord || "";
  }
};

/* add promotion code on page load */
if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
  window.discount = window.discount || [];
  var promoCode = localStorage.getItem("promocode");
  if(promoCode != null && window.discount.includes(promoCode)){
    setPromotionInputState(promoCode, true, true);
  } else {
    setPromotionInputState("", false, false);
  }
  window.promotionValidate().catch(function (error) { console.warn('Unable to initialize cart promotions.', error); });
}
